import { Progress } from 'antd';
import { useData } from '../../hooks/useData';
import './style.css';

const Overlay = ({ loadingOverlay }) => {
  if (!loadingOverlay?.visible) return null;
  const { title, description, percent } = loadingOverlay;
  return (
    <div className="loading-overlay">
      <div className="loader">
        <p className="loader-title">{title}</p>
        <p className="loader-description">{description}</p>
        <Progress percent={Math.round(percent || 0)} status="active" showInfo />
      </div>
    </div>
  );
};

export const LoadingOverlay = () => {
  const [loadingOverlay] = useData((s) => s.loadingOverlay);
  return <Overlay loadingOverlay={loadingOverlay} />;
};
